module.exports = "/dist/8ce598834dcde808ae5a52930d2f198c.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-100.woff2
// module id = 145
// module chunks = 0